module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/lion-btn-audio.258379d6.png";